/**
 * Removes color styles from HTML content (color, background-color)
 * Use this to sanitize rich text before storing or sending to API
 */
export const stripColorStyles = (html: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Remove color-related inline styles from all elements
    const allElements = doc.querySelectorAll('*');
    allElements.forEach((element) => {
        const style = element.getAttribute('style');
        if (style) {
            const cleanedStyle = style
                .split(';')
                .filter((declaration) => !declaration.includes('color') && !declaration.includes('background-color'))
                .join(';')
                .trim();
            if (cleanedStyle) {
                element.setAttribute('style', cleanedStyle);
            } else {
                element.removeAttribute('style');
            }
        }
    });

    return doc.body.innerHTML;
};
